import { Outlet, RouteObject } from 'react-router-dom';
import { UserLayout } from '@/layouts';
import {
	UserRegister,
	UserRegisterComplementation,
	UserRegisterGoogle,
	UserLogin,
	UserHome,
	UserMinhasConsultas,
	UserFormulario,
	UserFirstAccess,
	CreateUserSession,
	// UserIpbe,
	UserProfile,
	SessaoChamadaPage,
} from '@/pages';
import { UserClubs } from '@/pages/user/clubs/UserClubs';

export const userRoutes: Array<RouteObject> = [
	{
		path: '/',
		children: [
			{
				path: 'cadastro',
				element: <Outlet />,
				children: [
					{
						path: '',
						element: <UserRegister />,
					},
					{
						path: 'info',
						element: <UserRegisterGoogle />,
					},
					{
						path: 'info-complemento',
						element: <UserRegisterComplementation />,
					},
				],
			},
			{
				path: 'login',
				element: <UserLogin />,
			},
			{
				path: '',
				element: <UserLayout />,
				children: [
					{
						path: 'formulario',
						element: <UserFormulario />,
					},
					{
						path: 'primeiro-acesso',
						element: <UserFirstAccess />,
					},
					{
						path: 'home',
						element: <UserHome />,
					},
					{
						path: 'minhas-consultas',
						element: <UserMinhasConsultas />,
					},
					{
						path: 'sessao-chamada/:sessionId',
						element: <SessaoChamadaPage />,
					},
					{
						path: '/consulta',
						element: <CreateUserSession />,
					},
					{
						path: 'perfil',
						element: <UserProfile />,
					},
					// {
					// 	path: 'ipbe',
					// 	element: <UserIpbe />,
					// },
					{
						path: 'clubes',
						element: <UserClubs />,
					},
				],
			},
		],
	},
];
